package com.ijoin.data.model

import com.ijoin.data.model.serialization.InstantIso8601Serializer
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class EventTicketBookingRequest(
    val eventId: String,
    val quantity: Int = 1,
    val priceTierName: String? = null,
    val holderName: String? = null,
    val holderEmail: String? = null,
    @Serializable(with = InstantIso8601Serializer::class)
    val occurrenceDateTime: Instant? = null,
)
